import log from '../../lib/salvo-lite/log'
import ScrollOut from 'scroll-out'

class ScrollTools {
    constructor (elem) {
        this._elem = elem

        this._data = {
            siteHeader: document.querySelector('.site-header'),
            announcementBar: document.querySelector('#store-messages')
        }
    }

    onInit () {
        log.debug(this.constructor.name, 'Initialised', this)

        ScrollOut({
            targets: '.site-header',
            offset: 150// ,
            // onShown: () => {
            //     if (this._data.announcementBar) {
            //         this._data.siteHeader.style.transform = `translateY(-${this._data.announcementBar.offsetHeight}px)`
            //     }
            // },
            // onHidden: () => {
            //     if (this._data.announcementBar) {
            //         this._data.siteHeader.style.transform = 'translateY(0)'
            //     }
            // }
        })
    }
}

export default ScrollTools



// WEBPACK FOOTER //
// ./resources/scripts/components/ScrollTools.js